/* global debounce */
if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.disclosure = this.closest('details');

      if (this.disclosure && this.disclosure.matches('.cart-note-disclosure')) {
        this.cartNoteToggle = this.disclosure.querySelector('.js-show-note');
        this.giftNoteToggle = this.disclosure.querySelector('.js-show-note--gift-note');
      }

      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      this.init();
    }

    init() {
      this.debouncedHandleNoteChange = debounce(this.handleNoteChange.bind(this), 300);
      // Save as soon as possible, avoid link-click not providing time to save
      this.addEventListener('input', this.debouncedHandleNoteChange);
    }

    handleNoteChange(evt) {
      console.log(evt)
      if (this.cartNoteToggle) {
        const label = evt.target.value ? theme.strings.editCartNote : theme.strings.addCartNote;
        if (this.cartNoteToggle.textContent !== label) this.cartNoteToggle.textContent = label;
      }

      if (this.giftNoteToggle) {
        const label = evt.target.value ? theme.strings.editGiftNote : theme.strings.addGiftNote;
        if (this.giftNoteToggle.textContent !== label) this.giftNoteToggle.textContent = label;
      }
      
      if(evt.target.id !== 'gift-note') {
        this.fetchRequestOpts.body = JSON.stringify({ note: evt.target.value });
        fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
      }

      if(evt.target.id === 'gift-note') {
        this.fetchRequestOpts.body = JSON.stringify({ attributes: { 'Gift card message': evt.target.value } });
        fetch(theme.routes.cartUpdate, this.fetchRequestOpts)
        .then(response => response.json())
        .then(data => {
          console.log('Gift card text added:', data);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }
    }
  }

  customElements.define('cart-note', CartNote);
}
